module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<label class="checkbox">\n    <input type="checkbox">\n    <div class="checkboxStyle">\n        <span class="icon icon-i16_check_thin"></span>\n    </div>\n    '+
((__t=( resort.get('name') ))==null?'':__t)+
'\n</label>';
}
return __p;
};
